// Turning a template into an email for this salon. By default it wears the
// salon's brand (its look, colour, type, buttons, corners and logo). A named
// look instead shows the template in that look's own colours and type, with
// the salon's logo and name kept: a look to try for one email.
import { specWithKit, withThemeSpec, themeSpecFromBlocks, LOOKS } from './theme'
import { MARKET_LOOK } from '../data/templates'
import { resolveLocalLinks } from './links'

export const BRAND_LOOK = 'brand'
const STYLE_KEYS = ['accent', 'display', 'text', 'button', 'radius']
const IDENTITY_KEYS = ['logo', 'logoWidth', 'logoShape', 'logoShapeFor', 'name']

// The look the salon's brand uses: the one they saved, else their market's.
export const brandLookOf = (kit, market) => (kit && kit.look) || MARKET_LOOK[market] || 'gloss'

// The look a template was designed in (what the library shows "as designed").
export const designedLook = (tpl, market) => (
  tpl && LOOKS[tpl.look] ? tpl.look : (MARKET_LOOK[market] || 'gloss')
)

// The look a template opens in: the salon's brand unless another is picked.
export const templateLook = (tpl, { look } = {}) => look || BRAND_LOOK

// The theme spec a template gets for a look choice.
export const templateSpec = (tpl, { market, kit, look } = {}) => {
  const base = { ...(themeSpecFromBlocks(tpl.blocks) || {}) }
  const chosen = templateLook(tpl, { look })
  if (chosen === BRAND_LOOK) {
    ;[...STYLE_KEYS, ...IDENTITY_KEYS].forEach((k) => { delete base[k] })
    return specWithKit({ ...base, look: brandLookOf(kit, market) }, kit)
  }
  STYLE_KEYS.forEach((k) => { delete base[k] })
  const identity = {}
  IDENTITY_KEYS.forEach((k) => { if (kit && kit[k] !== undefined && kit[k] !== null && kit[k] !== '') identity[k] = kit[k] })
  return { ...base, look: chosen, ...identity }
}

export const buildTemplateBlocks = (tpl, { market, kit, look, links } = {}) => {
  const spec = templateSpec(tpl, { market, kit, look })
  const blocks = withThemeSpec(tpl.blocks, spec).map(b => (
    b.type === 'footer' ? { ...b, content: { ...b.content, preheader: tpl.preheader || '' } } : b
  ))
  return links ? resolveLocalLinks(blocks, links) : blocks
}
